<template>
  <div v-if="hasProductRecommendations" class="product-recommendations">
    <div class="product-recommendations__header">
      <h2 class="product-recommendations__title">
        {{ heading }}
      </h2>
    </div>
    <div class="product-recommendations__grid" :class="gridClasses">
      <ProductQueryWrapper
        v-for="recommendation in recommendations"
        :key="recommendation.id"
        v-slot="{ product }"
        :product-id="recommendation.product_id"
      >
        <ProductTile
          v-if="product"
          :product="productWithReferralPlacement(product)"
          :show-one-photo="true"
        />
      </ProductQueryWrapper>
    </div>
  </div>
</template>

<script>
import ProductQueryWrapper from "@/components/ProductQueryWrapper.vue";
import ProductTile from "@/components/ProductTile.vue";

export default {
  name: "NostoProductRecommendationsGrid",
  components: {
    ProductTile,
    ProductQueryWrapper,
  },
  props: {
    recommendations: {
      type: Array,
      default: () => [],
    },
    heading: {
      type: String,
      required: true,
    },
    placement: {
      type: String,
      default: null,
    },
    overflow: {
      type: Boolean,
      default: false,
    },
    dark: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    hasProductRecommendations() {
      return this.recommendations?.length >= 2;
    },
    gridClasses() {
      return {
        "product-recommendations__grid--overflow": this.overflow,
        "product-recommendations__grid--dark": this.dark,
      };
    },
  },
  methods: {
    productWithReferralPlacement(product) {
      if (!this.placement) {
        return product;
      }

      const newOnlineStoreUrl = new URL(product.onlineStoreUrl);
      newOnlineStoreUrl.searchParams.set("ref-placement", this.placement);

      return {
        ...product,
        onlineStoreUrl: newOnlineStoreUrl,
      };
    },
  },
};
</script>

<style lang="scss" scoped>
.product-recommendations {
  padding: 60px 0 0;

  @include respond-above(lg) {
    padding: 80px 0 0;
  }

  &__header {
    margin-bottom: 19px;
  }

  &__title {
    @include t__editorial_headline_10;
  }

  &__link {
    font-size: 8px;
    text-decoration: none;
    text-transform: uppercase;
    color: $color-dark;
    font-weight: 600;

    @include respond-above(md) {
      font-size: 10px;
    }
  }

  &__grid {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    column-gap: 2px;

    &--overflow {
      display: flex;
      overflow: auto;
      width: 100%;
      flex-flow: row nowrap;
      gap: 2px;

      & > ::v-deep(*) {
        flex: 1 0 194px;
      }
    }

    &--dark {
      ::v-deep(.product__title) {
        color: $color-white;
      }
    }
  }
}
</style>
